<template>
  <div class="header" :class="{bg:hasBg}">
    <img class="logo" src="@/assets/images/logo.png" />
    <div class="nav-icon" @click="toggle()">
      <img v-if="navShow" src="@/assets/images/close.png" />
      <img v-else src="@/assets/images/nav.png" />
    </div>
    <div class="navs" v-if="navShow">
      <div class="code">
        <img src="@/assets/images/code.png" />
        <span>微信公众号</span>
      </div>

      <div class="code-1">
        <img src="@/assets/images/code-1.png" />
      </div>

      <ul>
        <li>
          <a @click="goHome()">首页</a>
        </li>
        <li>
          <a @click="goHX()">核心优势</a>
        </li>
        <li>
          <a @click="goNews()">新闻中心</a>
        </li>
        <li>
          <a @click="goFW()">产品服务</a>
        </li>
        <li>
          <a @click="goYJ()">企业愿景</a>
        </li>
        <li>
          <a @click="goAbout()">关于我们</a>
        </li>
        <li>
          <div class="title">校区管理中心</div>
          <div class="links">
            <div class="item">
              <a href="https://eso-agent.jmnet.cn" target="_blank">机构管理平台</a>
            </div>
            <div class="item">
              <a href="https://cloud.fadada.com/application/account/login" target="_blank">法大大签约</a>
            </div>
          </div>
          <div class="title">学员管理中心</div>
          <div class="links">
            <div class="item">
              <a href="https://mxmbxx.kaowx.com/login" target="_blank">必过</a>
            </div>
            <div class="item">
              <a href="https://jsbxx.myunedu.com/studymobile/#/login" target="_blank">慧学</a>
            </div>
            <div class="item">
              <a href="https://jypxzxzaixian.myunedu.com/#/homePage" target="_blank">易过</a>
            </div>
            <div class="item">
              <a href="https://gh.edu.gzfeice.com/h5/mall/main/my" target="_blank">飞策</a>
            </div>
          </div>
          <div class="title">教务管理中心</div>
          <div class="links">
            <div class="item">
              <a href="https://oem.beeeeego.com/" target="_blank">必过</a>
            </div>
            <div class="item">
              <a href="https://bxx.myunedu.com/" target="_blank">慧学</a>
            </div>
            <div class="item">
              <a href="https://scrm.gzfeice.com/" target="_blank">飞策</a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { scrollTo } from '@/scroll-to.js'
export default {
  data() {
    return {
      hasBg: false,
      navShow: false,
      hasBgDefault: false,
    }
  },
  created() {

  },
  mounted() {
    if (this.$route.path === '/news' || this.$route.path === '/detail') {
			this.hasBg = true
			this.hasBgDefault = true
		} else {
			this.hasBg = false
			this.hasBgDefault = false
		}
    window.addEventListener('scroll', this.handleScroll);
  },
  computed: {},
  watch: {
		'$route'(to, from) {
			if (to.path === '/news' || to.path === '/detail') {
				this.hasBg = true
				this.hasBgDefault = true
			} else {
				this.hasBg = false
				this.hasBgDefault = false
			}
		}
	},
  methods: {
    toggle() {
      this.navShow = !this.navShow
      if (this.navShow) {
        this.hasBg = true
      } else {
        if (window.scrollY >= 50) {
          this.hasBg = true
        } else {
          this.hasBg = false
        }
      }
    },

    handleScroll() {
      if (this.hasBgDefault) {
				return
			}
      const scrollPosition = window.scrollY;
      if (scrollPosition >= 50) {
        this.hasBg = true
      } else {
        this.hasBg = false
      }
    },

    goAbout() {
      scrollTo(0)
      this.navShow = false
      this.hasBg = false
      if (window.location.hash !== '#/about') {
        this.$router.push('/about')
      }
    },
    goYJ() {
      scrollTo(3100)
      this.navShow = false
      if (window.location.hash !== '#/') {
        this.$router.push('/')
      }
    },
    goHX() {
      scrollTo(230)
      this.navShow = false
      if (window.location.hash !== '#/') {
        this.$router.push('/')
      }
    },
    goFW() {
      scrollTo(1050)
      this.navShow = false
      if (window.location.hash !== '#/') {
        this.$router.push('/')
      }
    },
    goHome() {
      scrollTo(0)
      this.navShow = false
      this.hasBg = false
      if (window.location.hash !== '#/') {
        this.$router.push('/')
      }
    },
    goNews() {
      this.navShow = false
      this.hasBg = true
			this.$router.push('/news')
		}
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  components: {
  }
}
</script>

<style scoped lang="less">
.header {
  padding: 0 0.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  z-index: 9;
  left: 0;
  right: 0;
  top: 0;
  height: 0.5rem;
  .logo {
    height: 0.3rem;
    width: auto;
  }
  .nav-icon {
    height: 0.3rem;
    width: 0.3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      height: 0.24rem;
      width: auto;
    }
    &:active {
      opacity: 0.5;
    }
  }

  .navs {
    background: #0f2fbe;
    position: absolute;
    box-shadow: #0f2fbe 0 0.6rem 1rem;
    top: 0.5rem;
    left: 0;
    right: 0;
    ul {
      padding: 0.1rem 0.2rem 0.1rem 0.2rem;
      li {
        padding: 0.1rem 0;
        display: flex;
        flex-direction: column;
        a {
          color: #fff;
          font-size: 0.16rem;
          &:active {
            opacity: 0.5;
          }
        }

        .title {
          margin-bottom: 0.05rem;
          opacity: 0.5;
          font-size: 0.12rem;
          border-top: rgba(255, 255, 255, 0.2) 0.01rem solid;
          padding-top: 0.1rem;
          color: #fff;
        }
        .links {
          margin-bottom: 0.1rem;
          display: flex;
          .item {
            flex: 1;
            a {
              display: block;
              padding: 0.05rem 0;
            }
          }
        }
      }
    }
  }
}
.code {
  display: flex;
  position: absolute;
  z-index: 9;
  top: 0.2rem;
  right: 0.2rem;
  background: #fff;
  border-radius: 0.08rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.1rem;
  img {
    width: 0.8rem;
    height: auto;
    display: block;
  }
  span {
    color: #a6a6a6;
    font-size: 13px;
  }
}
.code-1 {
  display: flex;
  position: absolute;
  z-index: 9;
  top: 1.2rem;
  right: 0.1rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.1rem;
  img {
    width: 1.8rem;
    height: auto;
    display: block;
  }
}
.bg {
  background: #0f2fbe;
}
</style>